import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 0 6px;
`

export const Label = styled.label`
  margin: 0 0.3rem;
  text-transform: capitalize;
`

export const Error = styled.p`
  margin: 3px 0 6px 0;
  color: #ab003c;
`

export const Input = styled.input`
  width: 100%;
  height: 48px;
  border: 1px solid #c7c9c7;
  box-sizing: border-box;
  border-radius: 4px;
  padding: 16px;

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px #2962ff;
  }
`
